import { LitElement, html, css } from 'lit'

customElements.define('k-itinerary', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        [toggles] {
            padding: .5em;
            background-color: var(--theme-muted);
            border-radius: 4px;
            text-wrap: balance;
        }

        [open] [toggles] {
            border-radius: 4px 4px 0 0;
        }

        ul {
            margin: 1em;
            padding: 0 0 0 1em;
        }

        b-details {
            border: solid 1px var(--theme-muted);
            border-radius: 4px;
            gap: 0;
        }
    `

    set data(val){
        let oldVal = this.data
        this.__data = val
    
        this.requestUpdate('data', oldVal)
    }
    
    get data(){ return this.__data}

    render(){return html`
        <b-grid cols=1>
        ${this.data?.map((d,i)=>html`
        <b-details noicon ?open=${i==0||this.data.length<=3}>

            <b-text toggles>${d.title.split(':').map((s,i)=>html`
                ${i==0?html`<b>${s}:</b> `:s}
            `)}</b-text>

            <ul>
            ${d.content.map(line=>html`
                <li>${line.replace(/^\s?[•●] /, '')}</li>
            `)}
            </ul>
        </b-details>
        `)}
        </b-grid>
    `}

})

export default customElements.get('k-itinerary')